import React from 'react';
import Header from '../../components/Header';
import TabSelector from '../../components/TabSelector';
import Footer from '../../components/Footer';
import UpdateNotice from '../../components/UpdateNotice';

const UploadPage: React.FC = () => {
	return (
		<>
			<Header />
			<UpdateNotice />
			<TabSelector />
			<Footer />
		</>
	);
};

export default UploadPage;
